var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { greys } from "@irati/ui/src/global/colors";
export default styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  box-shadow: 0 0 0 1px ", ";\n  ", "\n"], ["\n  width: 100%;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  box-shadow: 0 0 0 1px ", ";\n  ", "\n"])), greys.light, function (props) { return (props.compactMode ? "height: 104px" : null); });
var templateObject_1;
